'use client';
import { useTranslations as useTranslations$1 } from 'next-intl';
import Image from 'next/image';
import { MODEL_LOGOS } from '@/lib/marketing-config';
export function ModelLogos() {
    const t = useTranslations$1();
    return (<section className="border-t border-white/5 bg-black px-6 py-16 text-white md:px-8 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-start md:text-center">
          <p className="mb-8 text-sm font-light uppercase tracking-wider text-zinc-400 md:text-base">
            {t("M16pXh")}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            {MODEL_LOGOS.map((logo)=>(<Image key={logo.src} src={logo.src} alt={logo.alt} width={120} height={32} className="h-6 w-auto opacity-70 transition-opacity duration-300 hover:opacity-100 md:h-8"/>))}
          </div>
        </div>
      </div>
    </section>);
}
